import { makeAwsSignedRequest } from '../ApiService';

const DIAGNOSTIC_AI_TIMEOUT_MS = 300000;

export interface DiagnosticProcessorTrendPoint {
    date: string;
    count: number;
}

export interface DiagnosticProcessorTrendSummary {
    processor: string;
    firstCount: number;
    lastCount: number;
    absoluteChange: number;
    percentageChange?: number | null;
    peakCount: number;
    peakDate?: string | null;
    dailyCounts: DiagnosticProcessorTrendPoint[];
}

export interface AiDiagnosticQuestionResponse {
    answer: string;
    caveats: string[];
    topProcessors: DiagnosticProcessorTrendSummary[];
    windowStart?: string;
    windowEnd?: string;
    snapshotsAnalyzed: number;
    modelId?: string;
    generatedAt?: string;
}

export interface AskDiagnosticQuestionRequest {
    question: string;
    days: number;
    clientIds?: string[];
    processors?: string[];
    windowStart?: string;
    windowEnd?: string;
}

export const DiagnosticAiService = {
    askQuestion: (
        stage: string,
        realm: string,
        request: AskDiagnosticQuestionRequest,
    ): Promise<AiDiagnosticQuestionResponse> =>
        makeAwsSignedRequest(stage, realm, 'ai/diagnostic-question', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(request),
            retry: false,
            timeoutMs: DIAGNOSTIC_AI_TIMEOUT_MS,
        }),
};
